import React from "react";
import "./reports.scss";

const kpis = [
  { label: "Total News Imported", value: "1,248", change: "+12.5%", tone: "red" },
  { label: "Approved Leads", value: "426", change: "+8.3%", tone: "green" },
  { label: "EMS Synced Leads", value: "389", change: "+6.1%", tone: "blue" },
  { label: "AI Duplicate Rate", value: "18.4%", change: "-2.7%", tone: "orange" },
  { label: "Average AI Score", value: "82", change: "+4.2%", tone: "purple" },
];

const sourceData = [
  { label: "MyBina", value: 520 },
  { label: "DayakDaily", value: 260 },
  { label: "CIDB", value: 188 },
  { label: "Tender Portal", value: 166 },
  { label: "Others", value: 114 },
];

const statusData = [
  { label: "New", value: 145 },
  { label: "Merged", value: 98 },
  { label: "Approved", value: 72 },
  { label: "Synced", value: 46 },
  { label: "Archived", value: 18 },
];

const aiScoreData = [
  { label: "0-39", value: 18 },
  { label: "40-59", value: 48 },
  { label: "60-79", value: 176 },
  { label: "80-100", value: 284 },
];

const syncData = [
  { label: "Synced", value: 389 },
  { label: "Pending", value: 31 },
  { label: "Failed", value: 6 },
];

const topOpportunities = [
  {
    project: "Bintulu Mixed Development Hub",
    state: "Sarawak",
    value: "RM310M",
    source: "MyBina",
    aiScore: 90,
    assignedTo: "Michelle Wong",
  },
  {
    project: "Samarahan Boulevard Development",
    state: "Sarawak",
    value: "RM250M",
    source: "DayakDaily",
    aiScore: 88,
    assignedTo: "Unassigned",
  },
  {
    project: "Kuching Central Mall Extension",
    state: "Sarawak",
    value: "RM120M",
    source: "MyBina",
    aiScore: 92,
    assignedTo: "Alex Tan",
  },
  {
    project: "Sibu Private Medical Centre",
    state: "Sarawak",
    value: "RM95M",
    source: "MyBina",
    aiScore: 81,
    assignedTo: "Unassigned",
  },
];

const syncFailures = [
  {
    project: "Mukah Education Campus Upgrade",
    source: "Tender Portal",
    reason: "EMS customer mapping missing",
    time: "23 Jun 2026 11:02",
  },
  {
    project: "Kuching Warehouse & Logistics Centre",
    source: "CIDB",
    reason: "EMS timeout",
    time: "23 Jun 2026 10:48",
  },
  {
    project: "Miri Industrial Park Phase 3",
    source: "MyBina",
    reason: "Duplicate EMS reference",
    time: "23 Jun 2026 09:20",
  },
];

function BarChart({ title, data }) {
  const max = Math.max(...data.map((item) => item.value));

  return (
    <div className="report-card chart-card">
      <div className="report-card__header">
        <h3>{title}</h3>
      </div>

      <div className="bar-chart">
        {data.map((item) => (
          <div className="bar-chart__row" key={item.label}>
            <div className="bar-chart__label">{item.label}</div>
            <div className="bar-chart__track">
              <div
                className="bar-chart__bar"
                style={{ width: `${Math.max(8, (item.value / max) * 100)}%` }}
              />
            </div>
            <div className="bar-chart__value">{item.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function ScoreBadge({ value }) {
  const className =
    value >= 80 ? "score score--high" : value >= 60 ? "score score--medium" : "score score--low";

  return <span className={className}>{value}</span>;
}

export default function ReportsPage() {
  return (
    <div className="reports-page">
      <div className="reports-page__topbar">
        <div>
          <h2>Reports</h2>
          <p>Monitor news imports, lead performance, AI quality, and EMS synchronization.</p>
        </div>

        <button className="export-button" type="button">
          Export Report
        </button>
      </div>

      <div className="reports-filters">
        <input type="date" defaultValue="2026-06-01" />
        <input type="date" defaultValue="2026-06-30" />
        <select><option>All Sources</option><option>MyBina</option><option>DayakDaily</option><option>CIDB</option></select>
        <select><option>All States</option><option>Sarawak</option><option>Sabah</option><option>Selangor</option></select>
        <select><option>All Salesperson</option><option>Alex Tan</option><option>Michelle Wong</option><option>Jason Lee</option></select>
      </div>

      <div className="kpi-grid">
        {kpis.map((kpi) => (
          <div className={`kpi-card kpi-card--${kpi.tone}`} key={kpi.label}>
            <span>{kpi.label}</span>
            <strong>{kpi.value}</strong>
            <small>{kpi.change} vs last month</small>
          </div>
        ))}
      </div>

      <div className="charts-grid">
        <BarChart title="News Imported by Source" data={sourceData} />
        <BarChart title="Leads by Status" data={statusData} />
        <BarChart title="AI Score Distribution" data={aiScoreData} />
        <BarChart title="EMS Sync Status" data={syncData} />
      </div>

      <div className="tables-grid">
        <div className="report-card">
          <div className="report-card__header">
            <h3>Top High-Score Opportunities</h3>
          </div>

          <div className="report-table-wrapper">
            <table className="report-table">
              <thead>
                <tr>
                  <th>Project</th>
                  <th>State</th>
                  <th>Value</th>
                  <th>Source</th>
                  <th>AI Score</th>
                  <th>Assigned To</th>
                </tr>
              </thead>
              <tbody>
                {topOpportunities.map((item) => (
                  <tr key={item.project}>
                    <td><strong>{item.project}</strong></td>
                    <td>{item.state}</td>
                    <td>{item.value}</td>
                    <td>{item.source}</td>
                    <td><ScoreBadge value={item.aiScore} /></td>
                    <td>{item.assignedTo}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="report-card">
          <div className="report-card__header">
            <h3>Recent EMS Sync Failures</h3>
          </div>

          <div className="failure-list">
            {syncFailures.map((item) => (
              <div className="failure-item" key={item.project}>
                <strong>{item.project}</strong>
                <span>{item.reason}</span>
                <small>{item.source} · {item.time}</small>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
